// extracted by mini-css-extract-plugin
export var icon = "redHalvaWithSovcombank-module--icon--m-uc7";